// extracted by mini-css-extract-plugin
export default {"wrapper":"QBhAokR1dP","control":"c6cBvYXMwo","angle":"GWpqPXjSim","active":"MIbUqQQnBM","blank":"R3rt1j62FX","dark":"EvDJpQu7Jv"};